/* Northsheep — the contents list on a long-form page.

   Built from the headings that are actually in the text, at load, so it can
   never disagree with the document. Whoever edits the terms adds or renames a
   clause in the normal rich-text editor and the list follows; there is no
   second place to keep in step.

   Progressive by construction: the <nav> ships empty and hidden, and is only
   revealed once there is something to put in it. No script, or fewer than two
   headings, and the page is a clean document with no stub navigation.
*/
(function () {
  'use strict';

  /* Anything below two clauses is not a document that needs an index — and a
     one-item contents list looks like a mistake. */
  var MIN_HEADINGS = 2;

  function slug(text, used) {
    var base =
      text
        .toLowerCase()
        .replace(/[^\w\s-]/g, '')
        .trim()
        .replace(/\s+/g, '-')
        .slice(0, 60) || 'section';
    var id = base;
    var n = 2;
    /* Two clauses can legitimately share a title ("Returns" under both
       Consumers and Businesses), and duplicate ids would send both links to
       the first one. */
    while (used[id]) {
      id = base + '-' + n++;
    }
    used[id] = true;
    return id;
  }

  function build(section) {
    var content = section.querySelector('[data-ns-legal-content]');
    var nav = section.querySelector('[data-ns-legal-toc]');
    var list = section.querySelector('[data-ns-legal-toc-list]');
    if (!content || !nav || !list) return;

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2'));
    if (headings.length < MIN_HEADINGS) return;

    var used = {};
    /* An id the merchant already set in the editor wins, so a link shared in
       an email keeps working after a rewrite. */
    headings.forEach(function (h) {
      if (h.id) used[h.id] = true;
    });

    var frag = document.createDocumentFragment();
    headings.forEach(function (h) {
      var text = (h.textContent || '').trim();
      if (!text) return;
      if (!h.id) h.id = slug(text, used);
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = text;
      li.appendChild(a);
      frag.appendChild(li);
    });

    list.appendChild(frag);
    nav.hidden = false;

    /* Which clause you are in. Marked with aria-current rather than a class,
       so a screen reader is told the same thing the styling says. */
    if ('IntersectionObserver' in window) {
      var links = {};
      Array.prototype.forEach.call(list.querySelectorAll('a'), function (a) {
        links[a.getAttribute('href').slice(1)] = a;
      });
      var current = null;
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            var id = e.target.id;
            if (current === id) return;
            if (current && links[current]) links[current].removeAttribute('aria-current');
            current = id;
            if (links[id]) links[id].setAttribute('aria-current', 'true');
          });
        },
        /* A band across the upper third: a heading counts as "where you are"
           from the moment it reaches comfortable reading height, not when it
           touches the very top of the window. */
        { rootMargin: '-88px 0px -66% 0px', threshold: 0 }
      );
      headings.forEach(function (h) {
        io.observe(h);
      });
    }
  }

  /* Shopify's policy pages carry no section markup, so there is no <nav> to
     fill — it has to be created. Same document shape, same treatment: a
     terms page reached from checkout deserves the contents list as much as
     one reached from the footer. */
  function buildPolicy() {
    var body = document.querySelector('.shopify-policy__body');
    if (!body) return;
    if (body.querySelectorAll('h2').length < MIN_HEADINGS) return;

    var nav = document.createElement('nav');
    nav.className = 'ns-legal__toc';
    nav.setAttribute('data-ns-legal-toc', '');
    nav.hidden = true;
    nav.innerHTML =
      '<p class="ns-legal__toc-heading">' +
      /* The label in the store's own language. theme.liquid puts the
         translated string on <html> for policy pages, because this script
         has no Liquid of its own to read a locale from. */
      (document.documentElement.getAttribute('data-ns-toc-label') || 'Contents') +
      '</p><ol class="ns-legal__toc-list" data-ns-legal-toc-list></ol>';
    body.setAttribute('data-ns-legal-content', '');
    /* The nav is inserted before the text and the pair is laid out as the
       template's two columns by .shopify-policy__container's own grid rules
       below 990px it simply stacks, which is the right answer on a phone. */
    body.parentNode.insertBefore(nav, body);
    build({ querySelector: function (sel) {
      if (sel === '[data-ns-legal-content]') return body;
      if (sel === '[data-ns-legal-toc]') return nav;
      if (sel === '[data-ns-legal-toc-list]') return nav.querySelector('[data-ns-legal-toc-list]');
      return null;
    } });
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('.ns-legal'), build);
    /* Blog articles use the same markup contract via a neutral hook, so a
       care guide gets the same contents list without a second script. */
    Array.prototype.forEach.call(document.querySelectorAll('[data-ns-toc-scope]'), build);
    buildPolicy();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
